// src/App.js
import React, { useMemo } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { buildAntdTheme, FONT_FAMILY, RADIUS } from './utils/themeTokens';
import DashboardLayout from './layouts/DashboardLayout';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
// ⬇️ removed HomePage import
import Dashboard from './pages/dashboard/Dashboard';
import Employees from './pages/dashboard/Employees';
import Attendance from './pages/dashboard/Attendance';
import Payroll from './pages/dashboard/Payroll';
import Settings from './pages/dashboard/Settings';
import PrivateRoute from './components/PrivateRoute';
import Leaves from './pages/dashboard/Leaves';
import Reports from './pages/dashboard/Reports';

import 'antd/dist/reset.css';
import './styles/global.css';
import './styles/components.css';

// antd needs real colour values to compute its hover/active/background shades,
// so the active theme's colours are passed in here rather than CSS variables.
const ThemedConfigProvider = ({ children }) => {
  const { colors } = useTheme();
  const antdTheme = useMemo(() => buildAntdTheme(colors), [colors]);
  return <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>;
};

const AppComponent = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff', // public pages
          fontFamily: FONT_FAMILY,
          borderRadius: RADIUS.control,
        },
      }}
    >
      <AntApp>
        <BrowserRouter>
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />

              {/* Protected Routes */}
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <ThemeProvider>
                      <ThemedConfigProvider>
                        <div className="theme-transition">
                          <DashboardLayout />
                        </div>
                      </ThemedConfigProvider>
                    </ThemeProvider>
                  </PrivateRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="employees" element={<Employees />} />
                <Route path="attendance" element={<Attendance />} />
                <Route path="payroll" element={<Payroll />} />
                <Route path="leaves" element={<Leaves />} />
                <Route path="reports" element={<Reports />} />
                <Route path="settings" element={<Settings />} />
              </Route>

              {/* Catch-all → login */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </div>
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  );
};

export default AppComponent;
